(function() {
  'use strict';

  function buildSizeOptions(t, e) {
    const s = [];
    for (let i = t; i <= e + 0.0001; i += 0.25) {
      const t = Math.round(100 * i) / 100;
      let e;
      e = t % 1 == 0 ? t.toFixed(0) : t * 10 % 1 == 0 ? t.toFixed(1) : t.toFixed(2);
      s.push({ value: e, label: e });
    }
    return s;
  }

  function isQuarterSize(t) {
    if (!t) return false;
    const e = parseFloat(t);
    if (!Number.isFinite(e)) return false;
    const s = Math.round(100 * (e - Math.floor(e))) / 100;
    return 0.25 === s || 0.75 === s;
  }

  // ============================================================
  // SHARED: Find the visible price span (handles sale + regular)
  // ============================================================
  function findPriceSpan(container) {
    if (!container) return null;
    var candidates = container.querySelectorAll('.price-item');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.closest('s')) continue;
      if (el.closest('.visually-hidden')) continue;
      if (el.closest('.d-none')) continue;
      return el;
    }
    return container.querySelector('.price-item--regular, .price-item--last, .price__item, .price__number');
  }

  function initAllRingSizeSelectors() {
    document.querySelectorAll('[data-ring-size-selector]').forEach(function(container) {
      const SELECTOR_ID = container.dataset.selectorId;
      const SECTION_ID = container.dataset.sectionId;
      const BLOCK_ID = container.dataset.blockId;
      const FEE_VARIANT_ID = container.dataset.feeVariantId;
      const FEE_AMOUNT_CENTS = parseInt(container.dataset.feeAmountCents, 10) || 2500;
      const FEE_AMOUNT_FORMATTED = container.dataset.feeAmountFormatted || '$25';
      const select = document.getElementById(SELECTOR_ID);
      if (!select) return;

      const feeNotice = container.querySelector('.ring-size-selector__fee-notice');
      const errorEl = container.querySelector('.ring-size-selector__error');
      const productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
                          document.querySelector('sht-prd-frm form') ||
                          document.querySelector('form[action*="/cart/add"]:not(.installment)');
      if (!productForm) return;

      const priceContainer = document.getElementById('productPrice-' + SECTION_ID);

      function setError(t) {
        container.classList.toggle('has-error', t);
        if (errorEl) errorEl.hidden = !t;
      }

      function showFeeNotice(t) {
        if (feeNotice) feeNotice.hidden = !t;
      }

      function getOrInitState() {
        if (!window._productFeeState) window._productFeeState = {};
        const productId = productForm.id || 'default';
        if (!window._productFeeState[productId]) {
          const priceSpan = findPriceSpan(priceContainer);
          let originalPrice = 0;
          if (priceSpan) {
            if (priceSpan.dataset.originalPrice) {
              originalPrice = parseFloat(priceSpan.dataset.originalPrice);
            } else {
              const t = priceSpan.textContent.trim();
              const e = t.match(/[\d,.]+/);
              originalPrice = e ? parseFloat(e[0].replace(/,/g, '')) || 0 : 0;
              priceSpan.dataset.originalPrice = originalPrice.toString();
            }
          }
          window._productFeeState[productId] = {
            originalPrice: originalPrice,
            quarterSizeFee: 0,
            engravingFee: 0,
            customFinishFee: 0
          };
        }
        return window._productFeeState[productId];
      }

      function updateDisplayedPrice(addFee) {
        if (!priceContainer) return;
        const priceSpan = findPriceSpan(priceContainer);
        if (!priceSpan) return;

        const state = getOrInitState();
        const feeAmount = Math.round(FEE_AMOUNT_CENTS) / 100;
        state.quarterSizeFee = addFee ? feeAmount : 0;

        const newPrice = state.originalPrice + state.quarterSizeFee + state.engravingFee + (state.customFinishFee || 0);
        const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
        priceSpan.textContent = formatter.format(newPrice);

        let feeIndicator = priceContainer.querySelector('.ring-size-fee-included');
        if (addFee) {
          if (!feeIndicator) {
            feeIndicator = document.createElement('span');
            feeIndicator.className = 'ring-size-fee-included';
            feeIndicator.textContent = '(includes ' + FEE_AMOUNT_FORMATTED + ' quarter-size fee)';
            priceSpan.parentNode.insertBefore(feeIndicator, priceSpan.nextSibling);
          }
        } else if (feeIndicator) {
          feeIndicator.remove();
        }
      }

      document.addEventListener('engravingFeeChanged', function(e) {
        const productId = productForm.id || 'default';
        if (e.detail.productId === productId && window._productFeeState && window._productFeeState[productId]) {
          window._productFeeState[productId].engravingFee = e.detail.engravingFee;
        }
      });

      document.addEventListener('customFinishFeeChanged', function(e) {
        const productId = productForm.id || 'default';
        if (e.detail.productId === productId && window._productFeeState && window._productFeeState[productId]) {
          window._productFeeState[productId].customFinishFee = e.detail.customFinishFee;
        }
      });

      function upsertHiddenProperty(name, value) {
        const inputName = 'properties[' + name + ']';
        let input = productForm.querySelector('input[name="' + inputName + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = inputName;
          productForm.appendChild(input);
        }
        input.value = value;
      }

      function removeHiddenProperty(name) {
        const inputName = 'properties[' + name + ']';
        const input = productForm.querySelector('input[name="' + inputName + '"]');
        if (input) input.remove();
      }

      async function addFeeToCart(mainVariantId, quantity, ringSize) {
        const feeProps = { 'Fee for': 'Quarter size', 'Ring size': ringSize, 'Main variant id': String(mainVariantId), '_hidden': 'true' };
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(FEE_VARIANT_ID, 10), quantity: quantity, properties: feeProps }] })
        });
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error('Failed to add quarter-size fee: ' + errorText);
        }
        return response.json();
      }

      async function refreshCartSections(sectionIds) {
        if (!sectionIds.length) return {};
        const url = window.Shopify?.routes?.root
          ? window.Shopify.routes.root + '?sections=' + encodeURIComponent(sectionIds.join(','))
          : '/?sections=' + encodeURIComponent(sectionIds.join(','));
        const response = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (!response.ok) return {};
        return response.json();
      }

      function handleSizeChange() {
        const selectedSize = select.value;
        setError(false);
        const selectedValueEl = container.querySelector('.ring-size-selector__selected-value');
        if (selectedValueEl) selectedValueEl.textContent = selectedSize || '';
        const isQuarter = isQuarterSize(selectedSize);
        showFeeNotice(isQuarter);
        updateDisplayedPrice(isQuarter);
        if (selectedSize) {
          upsertHiddenProperty('Ring size', selectedSize);
          if (isQuarter) upsertHiddenProperty('Quarter-size fee', FEE_AMOUNT_FORMATTED);
          else removeHiddenProperty('Quarter-size fee');
        }
      }

      async function handleFormSubmit(e) {
        const selectedSize = select.value;
        if (!selectedSize) {
          e.preventDefault();
          e.stopImmediatePropagation();
          setError(true);
          select.focus();
          return;
        }
        setError(false);
        upsertHiddenProperty('Ring size', selectedSize);
        const isQuarter = isQuarterSize(selectedSize);
        if (!isQuarter) {
          removeHiddenProperty('Quarter-size fee');
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        upsertHiddenProperty('Quarter-size fee', FEE_AMOUNT_FORMATTED);
        const mainVariantInput = productForm.querySelector('input[name="id"]');
        if (mainVariantInput) mainVariantInput.disabled = false;
        const mainVariantId = mainVariantInput ? parseInt(mainVariantInput.value, 10) : null;
        if (!mainVariantId) {
          alert('Error: Could not determine product variant. Please refresh and try again.');
          return;
        }
        const quantityInput = productForm.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
        try {
          const cartDrawer = document.querySelector('sht-cart-drwr');
          const cartNotification = document.querySelector('sht-cart-noti');
          const cartDrawerForm = document.querySelector('sht-cart-drwr-frm');
          const cartNotiStyle = document.body.getAttribute('data-cart-noti-type');
          let sections = [];
          if (cartNotification && typeof cartNotification.getSectionsToRender === 'function')
            sections = sections.concat(cartNotification.getSectionsToRender() || []);
          if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
            sections = sections.concat(cartDrawer.getSectionsToRender() || []);
          const formData = new FormData(productForm);
          if (sections.length) formData.append('sections', sections.map(function(s) { return s.id; }).join(','));
          formData.append('sections_url', window.location.pathname);
          const cartAddUrl = window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
          const addResponse = await fetch(cartAddUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData });
          const addResult = await addResponse.json();
          if (addResult.status && addResult.status !== 200) throw new Error(addResult.description || 'Failed to add item to cart');
          if (cartDrawerForm && typeof cartDrawerForm.renderContents === 'function') cartDrawerForm.renderContents(addResult);
          if (cartNotification && typeof cartNotification.renderContents === 'function')
            cartNotification.renderContents(addResult, cartNotiStyle === 'popover_notification', productForm.querySelector('[type="submit"]'));
          if (cartNotiStyle === 'show_the_cart_drawer' && cartDrawer && typeof cartDrawer.openDrawer === 'function') {
            const messageEl = cartDrawer.querySelector('.js-drawer-message');
            if (messageEl && typeof messageEl.setActiveMessage === 'function') messageEl.setActiveMessage();
            cartDrawer.openDrawer();
          }
          await addFeeToCart(mainVariantId, quantity, selectedSize);
          const sectionIds = sections.map(function(s) { return s.id; }).filter(Boolean);
          if (sectionIds.length) {
            const refreshedSections = await refreshCartSections(sectionIds);
            const payload = Object.assign({}, addResult, { sections: refreshedSections });
            if (cartDrawerForm && typeof cartDrawerForm.renderContents === 'function') cartDrawerForm.renderContents(payload);
            if (cartNotification && typeof cartNotification.renderContents === 'function')
              cartNotification.renderContents(payload, cartNotiStyle === 'popover_notification', productForm.querySelector('[type="submit"]'));
          }
          document.dispatchEvent(new Event('cart:refresh'));
        } catch (error) {
          alert('Sorry, there was a problem adding this item to your cart. Please try again.');
        }
      }

      const minSize = parseFloat(container.dataset.minSize) || 4;
      const maxSize = parseFloat(container.dataset.maxSize) || 13;
      const sizes = buildSizeOptions(minSize, maxSize);
      sizes.forEach(function(size) {
        const option = document.createElement('option');
        option.value = size.value;
        option.textContent = size.label;
        select.appendChild(option);
      });

      select.addEventListener('change', handleSizeChange);
      productForm.addEventListener('submit', handleFormSubmit, true);

      // ============================================================
      // VARIANT CHANGE: Listen for variant ID input change
      // The theme dispatches change on input[name="id"] when variant changes.
      // We reset originalPrice and re-apply fees.
      // ============================================================
      var variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.addEventListener('change', function() {
          var productId = productForm.id || 'default';
          // Delete cached state so originalPrice is re-read from new variant price
          if (window._productFeeState) {
            delete window._productFeeState[productId];
          }
          // Wait for theme to finish rendering the new price
          if (select.value && isQuarterSize(select.value)) {
            setTimeout(function() { updateDisplayedPrice(true); }, 300);
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllRingSizeSelectors);
  } else {
    setTimeout(initAllRingSizeSelectors, 100);
  }
})();
